import { Flex, Paper, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons";
import Link from "next/link";

const BigLinkButton = ({
    href,
    title = "Up Next",
    description = "",
    icon = <IconArrowRight />,
    direction = "row",
}) => {
    return (
        <Link
            href={href}
            style={{
                textDecoration: "none",
                width: "100%",
                maxWidth: "350px",
            }}
        >
            <Paper
                sx={(theme) => ({
                    background:
                        theme.colorScheme == "dark"
                            ? theme.colors["dark"][6]
                            : undefined,
                    width: "100%",
                    "&:hover": {
                        background:
                            theme.colorScheme == "dark"
                                ? theme.colors["dark"][5]
                                : undefined,
                    },
                })}
                shadow="sm"
                radius="lg"
                p={15}
                my={20}
                withBorder
            >
                <Flex
                    align={"center"}
                    justify={"space-between"}
                    direction={direction}
                >
                    <Flex
                        direction={"column"}
                        align={direction == "row-reverse" ? "end" : "start"}
                    >
                        <Text fw={"bold"} component="p" m={0}>
                            {title}
                        </Text>
                        {!!description && (
                            <Text c="dimmed" component="p" m={0}>
                                {description}
                            </Text>
                        )}
                    </Flex>
                    {icon}
                </Flex>
            </Paper>
        </Link>
    );
};

export default BigLinkButton;
